<template>
    <div>
        <h2 v-if="!switchMode">Supsis-Instagram Integration Purchase</h2>
        <span v-if="!switchMode">
            Instagram Feature billed month-to-month. Your instagram service will be activated after you accept
            subscription.</span
        >
        <h2 v-if="switchMode">Instagram Plans</h2>
        <span v-if="switchMode">{{ $t("wp.selectBestPlan") }}</span>
        <div class="plans mt-5">
            <InstagramBasicPlanCard
                :selected="instagramBasicEnabled"
                :on-selected="() => onPlanSelected('instagram-basic')"
            />
            <InstagramPlusPlanCard
                :selected="instagramPlusEnabled"
                :on-selected="() => onPlanSelected('instagram-plus')"
            />
        </div>
    </div>
</template>

<script>
import { updateIntegration } from "../../../../../api/billing";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { sendSocketMessage } from "../../../../../utils/socketStream";
import InstagramBasicPlanCard from "./plans/InstagramBasicPlanCard";
import InstagramPlusPlanCard from "./plans/InstagramPlusPlanCard";
import _ from "lodash";

export default {
    name: "Purchase",
    props: {
        purchaseCompleted: {
            type: Function,
            default: () => {},
        },
        switchMode: {
            type: Boolean,
            default: false,
        },
    },
    components: { InstagramBasicPlanCard, InstagramPlusPlanCard },
    computed: {
        ...mapGetters({}),
        ...mapState({
            siteId: (state) => state.site.site._id,
            site: (state) => state.site.site,
            igInfo: (state) => state.instagram.info,
            instagramBasicEnabled: (state) => _.get(state.setting.settings, "instagram.plan") === "instagram-basic",
            instagramPlusEnabled: (state) => _.get(state.setting.settings, "instagram.plan") === "instagram-plus",
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
        }),
        ...mapMutations({
            changePurchaseStatus: "instagram/changePurchaseStatus",
        }),
        onPlanSelected(planType) {
            this.updateIntegration(planType, true);
        },
        async updateIntegration(key, status = false) {
            await updateIntegration(this.siteId, key, status);
            sendSocketMessage("user settings-updated", {
                siteId: this.siteId,
            });
            sendSocketMessage("user ig-purchase-event", {
                siteId: this.siteId,
            });
            this.getSettings();
            if (!this.switchMode) {
                this.changePurchaseStatus(status);
                this.purchaseCompleted();
            }
        },
    },
};
</script>
